import { FeatureHighlightConfig } from './feature-highlight.model';

export type FeatureHighlightKey =
  | 'advanced-grid-view'
  | 'custom-card-view'
  | 'bulk-edit-union-links'
  | 'bulk-edit-pension-links';

export function getFeatureHighlights(): Record<FeatureHighlightKey, FeatureHighlightConfig> {
  return {
    'advanced-grid-view': {
      addedDate: '2026-03-09',
      title: $localize`New: Advanced Grid View`,
      body: $localize`Group employees by tax unit, manager, or other property with the new advanced view. Try it now!`,
    },
    'custom-card-view': {
      addedDate: '2026-03-09',
      title: $localize`New: Custom Card Views`,
      body: $localize`Switch between All, Split (employee and position tabs) and Custom views to organize employee panels your way. Choose the layout that works best for you!`,
    },
    'bulk-edit-union-links': {
      addedDate: '2026-04-09',
      title: $localize`New: Change Union Links`,
      body: $localize`Bulk edit union links for multiple employees at once.`,
    },
    'bulk-edit-pension-links': {
      addedDate: '2026-04-20',
      title: $localize`New: Change Pension Links`,
      body: $localize`Bulk edit pension links for multiple employees at once.`,
    },
  };
}
